// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qj-2";
export var chatLink = "_qj-0";
export var chatText = "_qj-1";